import { HealthCardChecklist } from 'features/healthCard';
import { PolicySingleCard } from 'features/policySingle/components/PolicySingleCard';
import { StudentChecklist } from 'features/studentChecklist';
import { Policy } from 'models/policies';

interface PolicyChecklistsProps {
  withHealthCardChecklist: boolean;
  withStudentChecklist: boolean;
  policy: Policy;
}

export const PolicyChecklists = (props: PolicyChecklistsProps) => {
  const { withStudentChecklist, withHealthCardChecklist, policy } = props;

  if (!withStudentChecklist && !withHealthCardChecklist) return null;

  return (
    <div className="p-container">
      {withStudentChecklist && (
        <PolicySingleCard>
          <StudentChecklist />
        </PolicySingleCard>
      )}
      {withHealthCardChecklist && (
        <PolicySingleCard>
          <HealthCardChecklist policy={policy} />
        </PolicySingleCard>
      )}
    </div>
  );
};
